module.exports = __webpack_public_path__ + "img/vertical-loading.71e3acf9.gif";